import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export function useDeleteMeetingNote() {
  const queryClient = useQueryClient();

  const {
    mutateAsync,
    error,
    isPending: isLoading,
    reset,
  } = useMutation<unknown, Error, { meetingNoteId: string; clientId?: string; familyId?: string }>({
    mutationFn: ({
      clientId,
      familyId,
      meetingNoteId,
    }: {
      meetingNoteId: string;
      clientId?: string;
      familyId?: string;
    }) =>
      api.delete(
        familyId
          ? `families/${familyId}/meeting-notes/${meetingNoteId}`
          : `clients/${clientId}/meeting-notes/${meetingNoteId}`,
      ),
    onSuccess: (_data, { clientId }) => {
      if (clientId) {
        queryClient.invalidateQueries({ queryKey: ['clients', clientId, 'meeting-notes'] });
      }
    },
  });

  const deleteMeetingNote = async (clientId: string, meetingNoteId: string) => {
    return mutateAsync({ clientId, meetingNoteId });
  };

  const deleteFamilyMeetingNote = async (familyId: string, meetingNoteId: string) => {
    return mutateAsync({ familyId, meetingNoteId });
  };

  return {
    deleteMeetingNote,
    deleteFamilyMeetingNote,
    error,
    isLoading,
    reset,
  };
}
